module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "address flex-between",
    on: {
      "click": function($event) {
        _vm.addressPickerShow = true
      }
    }
  }, [_c('div', {
    staticClass: "address-left flex-start"
  }, [_c('img', {
    staticClass: "address-img",
    attrs: {
      "src": require("../../../assets/newImg/icon-address-location.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "address-detail"
  }, [_c('div', {
    staticClass: "address-pro"
  }, [_vm._v(_vm._s(_vm.address.address))]), _vm._v(" "), _c('div', {
    staticClass: "address-phone"
  }, [_vm._v("\n          " + _vm._s(_vm.address.name) + " " + _vm._s(_vm.address.phone) + "\n        ")])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "address-back"
  })]), _vm._v(" "), _vm._l((_vm.order_list), function(order, index) {
    return _c('div', {
      staticClass: "border-top"
    }, [(order.open_seller_fenxiao == 2) ? _c('div', {
      staticClass: "row-title"
    }, [_c('div', {
      staticClass: "title-left"
    }, [_c('img', {
      staticClass: "row-title-img",
      attrs: {
        "src": order.business_pic_url,
        "alt": ""
      }
    }), _vm._v("\n        " + _vm._s(order.business_name) + "\n      ")]), _vm._v(" "), (order.coupon_list.length > 0) ? _c('div', {
      staticClass: "title-right",
      on: {
        "click": function($event) {
          return _vm.couponSelect(index)
        }
      }
    }, [_vm._v("\n        选择优惠券(" + _vm._s(order.coupon_list.length) + ")\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((order.goods_items), function(goods, index2) {
      return _c('div', [_c('div', {
        staticClass: "flex-between row-between"
      }, [_c('div', {
        staticClass: "between-left flex-start"
      }, [_c('img', {
        staticClass: "between-left-img",
        attrs: {
          "src": goods.pic_url,
          "alt": ""
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "goods-box"
      }, [_c('div', {
        staticClass: "between-left-title"
      }, [_vm._v(_vm._s(goods.title))]), _vm._v(" "), _c('div', {
        staticClass: "between-left-detail gray-light"
      }, [_vm._v("\n              " + _vm._s(goods.sku.sku_formart) + "\n            ")]), _vm._v(" "), _c('div', {
        staticClass: "between-left-price"
      }, [_vm._v("¥" + _vm._s(goods.price))])])]), _vm._v(" "), _c('div', {
        staticClass: "between-right"
      }, [_c('div', {
        staticClass: "between-right-num gray-light"
      }, [_c('span', [_vm._v("数量")]), _vm._v("\n            " + _vm._s(goods.count) + "\n          ")])])]), _vm._v(" "), (_vm.pageData.total_credit > 0) ? _c('van-cell-group', [_c('van-cell', {
        attrs: {
          "title": "使用积分",
          "label": '已抵扣' + goods.discount_price + '元'
        }
      }, [_c('van-stepper', {
        attrs: {
          "min": 0,
          "integer": "",
          "max": _vm.credit_limit[index2]
        },
        model: {
          value: (goods.use_credit),
          callback: function($$v) {
            _vm.$set(goods, "use_credit", $$v)
          },
          expression: "goods.use_credit"
        }
      })], 1), _vm._v(" "), (_vm.pageData.cert_status) ? _c('van-notice-bar', [(_vm.credit_limit[index2] > 0) ? _c('span', [_vm._v("您有" + _vm._s(_vm.pageData.total_credit) + "积分,本商品最多可使用" + _vm._s(_vm.credit_limit[index2]) + "积分")]) : _c('span', [_vm._v("该商品不可使用 积分")])]) : _c('van-notice-bar', {
        directives: [{
          name: "rblink",
          rawName: "v-rblink",
          value: ({
            name: 'MyInfo',
            query: {}
          }),
          expression: "{ name: 'MyInfo', query: {} }"
        }]
      }, [_vm._v("您有" + _vm._s(_vm.pageData.total_credit) + "积分,实名认证后可用\n          >")])], 1) : _vm._e(), _vm._v(" "), (_vm.formData.goods_items[index2].properties.length > 0) ? _c('div', {
        staticClass: "flex-between row-list border-bottom"
      }, [_c('div', [_vm._v(_vm._s(_vm.formData.goods_items[index2].properties[0].k))]), _vm._v(" "), _c('div', {
        staticClass: "row-right flex-end"
      }, [_vm._v("\n          " + _vm._s(_vm.formData.goods_items[index2].properties[0].v[0].name) + "\n        ")])]) : _vm._e()], 1)
    }), _vm._v(" "), _c('div', {
      staticClass: "flex-between row-list border-bottom"
    }, [_c('div', [_vm._v("商品金额")]), _vm._v(" "), _c('div', {
      staticClass: "row-right flex-end"
    }, [_vm._v("¥" + _vm._s(order.goods_price))])]), _vm._v(" "), _c('div', {
      staticClass: "flex-between row-list border-bottom"
    }, [_c('div', [_vm._v("运费")]), _vm._v(" "), _c('div', {
      staticClass: "row-right flex-end"
    }, [_vm._v("¥" + _vm._s(order.express_price))])]), _vm._v(" "), _c('div', {
      staticClass: "flex-between row-list border-bottom"
    }, [_c('div', [_vm._v("优惠")]), _vm._v(" "), _c('div', {
      staticClass: "row-right flex-end"
    }, [_c('span', [_vm._v("¥" + _vm._s(_vm.discount_price))])])]), _vm._v(" "), _c('div', {
      staticClass: "row-list"
    }, [_c('div', [_vm._v("买家留言")]), _vm._v(" "), _c('div', {
      staticClass: "message-text"
    }, [_c('input', {
      attrs: {
        "type": "text",
        "placeholder": "您还有其他什么要求..."
      },
      on: {
        "change": function($event) {
          return _vm.noteChange(order.business_id, $event)
        }
      }
    })])])], 2)
  }), _vm._v(" "), (_vm.chima_show) ? _c('div', {
    staticClass: "chima"
  }, [_c('van-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.onDown
    }
  }, [_vm._v("尺码表")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "44px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "footer flex-between"
  }, [_c('div', {
    staticClass: "footer-left flex-start"
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("总计")]), _vm._v("\n      ¥" + _vm._s(_vm.pay_price) + "\n    ")]), _vm._v(" "), (!_vm.submitLoading) ? _c('div', {
    staticClass: "footer-right",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n      去支付\n    ")]) : _c('div', {
    staticClass: "footer-right"
  }, [_vm._v("提交中...")])]), _vm._v(" "), _c('AddressPicker', {
    attrs: {
      "show": _vm.addressPickerShow
    },
    on: {
      "onChange": _vm.changeAddress,
      "onClose": _vm.closeAddress
    }
  }), _vm._v(" "), _c('PayDialog', {
    attrs: {
      "scene": "goods",
      "show": _vm.payDialogShow,
      "ids": _vm.orderIds
    },
    on: {
      "onPayError": _vm.onPayError,
      "onPaySuccess": _vm.onPaySuccess,
      "onPayClose": _vm.onPayClose
    }
  }), _vm._v(" "), _c('CouponPicker', {
    attrs: {
      "show": _vm.couponPickerShow,
      "list": _vm.currentCouponList,
      "business_id": _vm.currentBusinessId,
      "index": _vm.currentBusinessIndex
    },
    on: {
      "onChange": _vm.changeCoupon
    }
  }), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "address-right"
  }, [_c('img', {
    staticClass: "icon-right-tip",
    attrs: {
      "src": require("../../../assets/images/icon-right.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-069ba0e5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index/order/OrderCheck.vue
// module id = 2190
// module chunks = 0